/**
 * 文档转换工具视觉配置
 * source / target 对应格式徽章，用于列表封面与详情页示意
 */
var FORMATS = {
  pdf: {
    id: 'pdf',
    label: 'PDF',
    color: '#C0392B',
    bg: '#FDEDEB',
    lines: 4
  },
  word: {
    id: 'word',
    label: 'Word',
    color: '#2B579A',
    bg: '#E8EEF7',
    lines: 5
  },
  excel: {
    id: 'excel',
    label: 'Excel',
    color: '#1D6F42',
    bg: '#E8F5EE',
    grid: true
  },
  ppt: {
    id: 'ppt',
    label: 'PPT',
    color: '#D24726',
    bg: '#FDEDE8',
    lines: 3
  },
  image: {
    id: 'image',
    label: 'Image',
    color: '#D68910',
    bg: '#FEF5E7',
    image: true
  },
  zip: {
    id: 'zip',
    label: 'ZIP',
    color: '#5D6D7E',
    bg: '#ECEFF1',
    stack: true
  }
}

var TOOL_FORMATS = {
  'pdf-to-word': { source: 'pdf', target: 'word' },
  'image-to-word': { source: 'image', target: 'word' },
  'pdf-to-excel': { source: 'pdf', target: 'excel' },
  'pdf-to-ppt': { source: 'pdf', target: 'ppt' },
  'pdf-to-image': { source: 'pdf', target: 'image' },
  'word-to-pdf': { source: 'word', target: 'pdf' },
  'excel-to-pdf': { source: 'excel', target: 'pdf' },
  'image-to-pdf': { source: 'image', target: 'pdf' },
  'word-to-image': { source: 'word', target: 'image' }
}

var DOCUMENT_TOOL_IDS = Object.keys(TOOL_FORMATS)

function getFormat(formatId) {
  return FORMATS[formatId] || null
}

function getDocConvertVisual(toolId) {
  var mapping = TOOL_FORMATS[toolId]
  if (!mapping) return null
  return {
    source: getFormat(mapping.source),
    target: getFormat(mapping.target)
  }
}

function isDocumentTool(toolId) {
  return !!TOOL_FORMATS[toolId]
}

export { FORMATS, TOOL_FORMATS, DOCUMENT_TOOL_IDS, getFormat, getDocConvertVisual, isDocumentTool }
export default { FORMATS, TOOL_FORMATS, DOCUMENT_TOOL_IDS, getFormat, getDocConvertVisual, isDocumentTool }
